/**
 * Checks if the provided email is a Ducky email
 *
 * @param email - String
 * @returns Boolean
 */
export function isAdminEmail(email = '') {
  return /\w+@ducky\.eco$/u.test(email);
}
